import { c as _c } from "react/compiler-runtime";
import { ImageCard } from "./image-card.component";
import { CardListItem } from "./card-list-item.component";
import type { FeatureCardsLayout } from "@/components/navigation/navigation.types";
import type { DesignColorValue } from "@/lib/design-colors";
interface FeatureCardsProps {
  layout: FeatureCardsLayout;
  colour?: DesignColorValue | null;
}
export function FeatureCards(t0) {
  const $ = _c(14);
  const {
    layout,
    colour
  } = t0;
  if (!layout.cards || layout.cards.length === 0) {
    return null;
  }
  switch (layout.type) {
    case "oneCard":
      {
        const card_1 = layout.cards[0];
        if (!card_1) {
          return null;
        }
        let t1;
        if ($[0] !== card_1 || $[1] !== colour) {
          t1 = <ImageCard card={card_1} size="large" colour={colour} />;
          $[0] = card_1;
          $[1] = colour;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "twoCards":
      {
        let t1;
        if ($[3] !== colour || $[4] !== layout.cards) {
          let t2;
          if ($[6] !== colour) {
            t2 = card_0 => <ImageCard key={card_0.id} card={card_0} size="medium" colour={colour} />;
            $[6] = colour;
            $[7] = t2;
          } else {
            t2 = $[7];
          }
          t1 = layout.cards.slice(0, 2).filter(Boolean).map(t2);
          $[3] = colour;
          $[4] = layout.cards;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        let t2;
        if ($[8] !== t1) {
          t2 = <div className="grid grid-cols-2 gap-4">{t1}</div>;
          $[8] = t1;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        return t2;
      }
    case "list":
      {
        let t1;
        if ($[10] !== layout.cards) {
          t1 = layout.cards.filter(Boolean).map(_temp);
          $[10] = layout.cards;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        let t2;
        if ($[12] !== t1) {
          t2 = <ul className="flex flex-col gap-3">{t1}</ul>;
          $[12] = t1;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        return t2;
      }
    default:
      {
        return null;
      }
  }
}
function _temp(card) {
  return <li key={card.id}><CardListItem card={card} /></li>;
}